module.exports = __webpack_public_path__ + "media/images/emblems/Obersaxen_wappen-ec0c310b1ab4ee93ab235d5b91fffe11.svg";